// For show more / less buttons on mobile / tablet

window.addEventListener('load', () => {
    const showMoreButton = document.querySelectorAll('.show-more-less-button');
    if (showMoreButton.length) {

        showMoreButton.forEach((element) => {
            let largeHeight = 0;
            let smallHeight = 0;
            let firstRun = 0;
            element.addEventListener('click', function (event) {
                let target = event.target;
                let targetParent = target.closest('section')
                let finalHeight = (largeHeight - smallHeight) * -1;
                let currentScroll = window.scrollY;
                let changeScrollPosition = true;

                if (element.querySelector('span').dataset.changeScrollPos) {
                    changeScrollPosition = false;
                }

                if (changeScrollPosition) {
                    if (element.querySelector('span').innerHTML !== element.querySelector('span').dataset.lessText) {
                        element.querySelector('span').innerHTML = element.querySelector('span').dataset.lessText;
                        smallHeight = targetParent.offsetHeight;
                    } else {
                        element.querySelector('span').innerHTML = element.querySelector('span').dataset.moreText;
                        document.querySelector('html').style.scrollBehavior = 'auto';
                        largeHeight = targetParent.offsetHeight;
                        finalHeight = (largeHeight - smallHeight) * -1;
                        window.scrollBy(0, finalHeight);
                        document.querySelector('html').style.scrollBehavior = 'smooth';
                    }
                }


                let cardPanel = element.closest('section');
                const hiddenCards = cardPanel.querySelectorAll('.was-hidden');
                hiddenCards.forEach(ele => {
                    ele.classList.toggle('hidden');
                });

                const expandFlip = cardPanel.querySelectorAll('.flip-when-expand');
                expandFlip.forEach(ele => {
                    ele.classList.toggle('-scale-x-100');
                });

                if (changeScrollPosition) {
                    if (firstRun == 0) {
                        document.querySelector('html').style.scrollBehavior = 'auto';
                        window.scrollTo(0, currentScroll);
                        document.querySelector('html').style.scrollBehavior = 'smooth';
                        firstRun = 1;
                    }
                }
            });
        });
    }
});